<div class="confirm-container">
  <span mat-dialog-title>Add Unit Set-Aside Type</span>
  <div mat-dialog-content>
    <div><b>Current List of Set-Aside Types</b></div>

    <ul>
      @for (type of setAsideTypes; track type) {
        <li>
          {{type.name}}
        </li>
      }
    </ul>

    <div>
      <mat-form-field appearance="fill">
        <mat-label>New Set-Aside Type</mat-label>
        <input matInput [(ngModel)]="newSetAsideType">
      </mat-form-field>
    </div>

    @if (checkName()) {
      <div>
        <small class="text-warning">Enter a unique Set-Aside Type.</small>
      </div>
    }
  </div>

  <div mat-dialog-actions style="float:right;margin:20px;">
    <button mat-button [mat-dialog-close]="{ clicked: 'Ok', newSetAsideType: newSetAsideType }" [disabled]="checkName()">Ok</button>
    <button mat-button (click)="onNoClick()">
      Cancel
    </button>
  </div>
</div>
